module.exports = __webpack_public_path__ + "img/logo_blanco.267f1829.png";